<script lang="ts">
    import { tooltip } from '@svelte-plugins/tooltips';

    import { TimeWindow } from '../TimeWindow';
    import IconTimeWindow from '../../../shared/Icons/IconTimeWindow.svelte';
    import Dummy from '../../../shared/Dummy.svelte';
    import ErrorColor from '../../../shared/ErrorColor.svelte';
    import TimeWindowText from './TimeWindowText.svelte';

    export let timeWindow: TimeWindow | null = null;
    export let minimizeView: boolean = false;
</script>

<div>
    {#if timeWindow && timeWindow.isValid()}
        {#if minimizeView}
            <span
                use:tooltip={{
                    content: { component: TimeWindowText, props: { timeWindow } },
                    theme: 'lastmile-tooltip-no-events',
                }}
            >
                <svelte:component this={timeWindow.getColorComponent()}>
                    <IconTimeWindow scale={0.7} />
                </svelte:component>
            </span>
        {:else}
            <TimeWindowText {timeWindow} />
        {/if}
    {/if}
</div>
